import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';
import { toArray } from '../_utils/react-children';
import classNames from 'classnames';
import { isString, getItemWidth, renderReactNodeFunction, isElementInViewport, DEFAUTL_PADDING } from './util';
import { useOnClickOutside } from '../_utils/hooks';
import { Icon } from '../index';
import usePopper from '../_utils/usePopper';
import devWarning from '../_utils/devwarning';
import { MENU_ITEM_CONTAINER_NAME } from './menuItem';

var SubMenu = function SubMenu(props) {
  var _classNames2, _classNames3, _context4;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _a = getCompProps('MenuSubMenu', userDefaultProps, props),
      customPrefixcls = _a.prefixCls,
      theme = _a.theme,
      mode = _a.mode,
      title = _a.title,
      icon = _a.icon,
      disabled = _a.disabled,
      children = _a.children,
      collapsed = _a.collapsed,
      keyValue = _a.keyValue,
      selectedKey = _a.selectedKey,
      selectedKeyPath = _a.selectedKeyPath,
      setSelectedKeyPath = _a.setSelectedKeyPath,
      openKeys = _a.openKeys,
      triggerSubMenuAction = _a.triggerSubMenuAction,
      forceSubMenuRender = _a.forceSubMenuRender,
      inlineIndent = _a.inlineIndent,
      className = _a.className,
      style = _a.style,
      handleOnOpenChange = _a.handleOnOpenChange,
      _a$paddingLeft = _a.paddingLeft,
      paddingLeft = _a$paddingLeft === void 0 ? 0 : _a$paddingLeft,
      restProps = __rest(_a, ["prefixCls", "theme", "mode", "title", "icon", "disabled", "children", "collapsed", "keyValue", "selectedKey", "selectedKeyPath", "setSelectedKeyPath", "openKeys", "triggerSubMenuAction", "forceSubMenuRender", "inlineIndent", "className", "style", "handleOnOpenChange", "paddingLeft"]);

  var isVertical = mode === 'vertical'; // 初始化level

  if (!restProps.level) {
    restProps.level = 1;
  }

  if (Array.isArray(restProps.parentPath)) {
    var _context;

    restProps.parentPath = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(restProps.parentPath), [keyValue]);
  } else {
    restProps.parentPath = [keyValue];
  }

  if (mode === 'inline') {
    restProps.subMenuMode = 'vertical';
    restProps.popupOffset = [];
  }

  devWarning(!children, 'submenu', 'cannot found children in Menu.SubMenu'); // className前缀

  var prefixCls = getPrefixCls(pkgPrefixCls, 'menu-submenu', customPrefixcls);
  var subMenuRef = React.useRef(null);
  var subMenuWrapperRef = React.useRef(null);
  var subMenuVerticalRef = React.useRef(null);
  var subMenuWrapperVerticalRef = React.useRef(null);

  var visible = Array.isArray(openKeys) && _includesInstanceProperty(openKeys).call(openKeys, keyValue);

  React.useEffect(function () {
    if (!visible || isVertical) return;
    var subMenuWrapperEle = subMenuWrapperRef.current;
    var subMenuEle = subMenuRef.current;

    if (subMenuWrapperEle && isElementInViewport(subMenuEle)) {
      var position = subMenuWrapperEle.getBoundingClientRect();
      var windowHeight = document.body.offsetHeight;

      if (position.bottom > windowHeight) {
        subMenuWrapperEle.style.transform = "translate(0px,-".concat(position.bottom - windowHeight, "px)");
      }
    }
  });

  var getPaddingRight = function getPaddingRight() {
    if (collapsed && restProps.level === 1) {
      return 0;
    }

    return DEFAUTL_PADDING;
  };

  var getPaddingLeft = function getPaddingLeft() {
    if (restProps.level > 1 && mode !== 'inline') {
      return DEFAUTL_PADDING;
    }

    if (restProps.level === 1 && icon) {
      return 0;
    } // 无图标显示首个字符不需要paddingleft


    if (!icon && collapsed && restProps.level === 1 && typeof title === 'string') {
      return 0;
    }

    return inlineIndent + paddingLeft;
  };

  var curPaddingRight = getPaddingRight();
  var curPaddingLeft = getPaddingLeft();
  var getCurrentStyle = React.useCallback(function () {
    var _a; // 内嵌模式height主要是用来动画的，必须要设置overflow溢出隐藏


    if (mode === 'inline') {
      var height = ((_a = subMenuWrapperRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
      return {
        height: visible && !collapsed ? "".concat(height, "px") : '0px',
        overflow: 'hidden',
        opacity: visible && !collapsed ? 1 : 0,
        transition: 'all 0.2s cubic-bezier(0,.4,.4,1)'
      };
    }

    var style = {
      visibility: forceSubMenuRender && !visible ? 'visible' : 'hidden'
    };

    if (restProps.subMenuMode === 'horizontal') {
      style.display = 'flex';
    }

    var _ref = subMenuRef.current || {
      offsetTop: 0
    },
        offsetTop = _ref.offsetTop;

    var popupOffsetPosition = restProps.popupOffset;

    if (!Array.isArray(popupOffsetPosition) || popupOffsetPosition.length === 0) {
      popupOffsetPosition = [0, 0];
    }

    if (popupOffsetPosition.length === 1) {
      popupOffsetPosition = _concatInstanceProperty(popupOffsetPosition).call(popupOffsetPosition, 0);
    }

    return _extends(style, {
      position: 'absolute',
      top: "".concat(offsetTop, "px"),
      left: '100%',
      paddingLeft: "".concat(popupOffsetPosition[0], "px"),
      paddingTop: "".concat(popupOffsetPosition[1], "px")
    });
  }, [subMenuRef, restProps.popupOffset, forceSubMenuRender, visible, mode, restProps.subMenuMode]);

  var handleVisibleChange = function handleVisibleChange(status) {
    var clean = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    handleOnOpenChange(keyValue, status, clean);
  };

  var closeSubMenu = function closeSubMenu() {
    handleVisibleChange(false, true);
  }; // 点击区域外的地方关闭


  useOnClickOutside([subMenuVerticalRef, subMenuWrapperVerticalRef], function (e) {
    var _a;

    var className = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.className) || '';

    if (!_includesInstanceProperty(className).call(className, MENU_ITEM_CONTAINER_NAME)) {
      closeSubMenu();
    }
  });

  var handleMouseEvent = function handleMouseEvent(status) {
    if (disabled || triggerSubMenuAction === 'click') return;
    handleVisibleChange(status);
  };

  var handleOnMouseEnter = function handleOnMouseEnter() {
    handleMouseEvent(true);
  };

  var handleOnMouseLeave = function handleOnMouseLeave() {
    handleMouseEvent(false);
  };

  var handleOnClick = function handleOnClick(info) {
    if (triggerSubMenuAction === 'click' && isVertical) {
      closeSubMenu();
    }

    restProps.handleOnClick && restProps.handleOnClick(info);
  }; // 子菜单展开收缩


  var handleOnClickSubMenu = function handleOnClickSubMenu() {
    if (disabled || triggerSubMenuAction === 'hover') return;
    handleVisibleChange(!visible);
  };

  var renderItemTitle = function renderItemTitle() {
    if (!icon && collapsed && restProps.level === 1 && isString(title)) {
      return /*#__PURE__*/React.createElement("p", null, title.charAt(0));
    }

    if (isString(title)) {
      return /*#__PURE__*/React.createElement("span", null, title);
    }

    return renderReactNodeFunction(title);
  };

  var renderItemArrow = function renderItemArrow() {
    var _context2;

    if (mode !== 'inline' || collapsed) return null;
    return /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down",
      className: classNames("".concat(prefixCls, "-arrow"), _defineProperty({}, _concatInstanceProperty(_context2 = "".concat(prefixCls, "-arrow-")).call(_context2, visible ? 'up' : 'down'), true))
    });
  };

  if (restProps.subMenuMode === 'horizontal' && restProps.level > 1 && children) {
    var _context3;

    var width = getItemWidth(children);
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(prefixCls, "-thrid-item")),
      style: {
        width: width
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(prefixCls, "-thrid-title"))
    }, /*#__PURE__*/React.createElement("span", null, title)), /*#__PURE__*/React.createElement("ul", {
      className: classNames("".concat(prefixCls, "-thrid-list"), restProps.popupClassName)
    }, _mapInstanceProperty(_context3 = toArray(children)).call(_context3, function (item, i) {
      return /*#__PURE__*/React.cloneElement(item, {
        level: restProps.level + 1,
        subMenuMode: restProps.subMenuMode,
        keyValue: item && item.key || i,
        collapsed: collapsed,
        mode: mode,
        selectedKey: selectedKey,
        openKeys: openKeys,
        forceSubMenuRender: forceSubMenuRender,
        triggerSubMenuAction: triggerSubMenuAction,
        handleOnOpenChange: handleOnOpenChange,
        handleOnClick: handleOnClick
      });
    })));
  }

  var mouseEvent = {
    onMouseLeave: handleOnMouseLeave,
    onMouseEnter: handleOnMouseEnter,
    onClick: handleOnClickSubMenu
  };
  var titleStyle = {
    paddingRight: "".concat(curPaddingRight, "px"),
    paddingLeft: "".concat(curPaddingLeft, "px")
  }; // eslint-disable-next-line react-hooks/rules-of-hooks

  var verticalView = usePopper( /*#__PURE__*/React.createElement("li", _extends({
    className: classNames(prefixCls, className, (_classNames2 = {}, _defineProperty(_classNames2, "light", theme === 'light'), _defineProperty(_classNames2, "".concat(prefixCls, "-collapsed"), collapsed), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames2, "".concat(prefixCls, "-hover"), !disabled && Array.isArray(openKeys) && _includesInstanceProperty(openKeys).call(openKeys, keyValue)), _defineProperty(_classNames2, "".concat(prefixCls, "-active"), Array.isArray(selectedKeyPath) && _includesInstanceProperty(selectedKeyPath).call(selectedKeyPath, keyValue)), _classNames2)),
    ref: subMenuVerticalRef,
    key: keyValue
  }, {
    onMouseLeave: handleOnMouseLeave,
    onMouseEnter: handleOnMouseEnter,
    onClick: handleOnClickSubMenu
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-title")),
    style: titleStyle
  }, icon && /*#__PURE__*/React.cloneElement(renderReactNodeFunction(icon), {
    className: classNames("".concat(prefixCls, "-icon"))
  }), renderItemTitle(), renderItemArrow())), /*#__PURE__*/React.createElement("div", {
    ref: subMenuWrapperVerticalRef,
    onMouseLeave: function onMouseLeave() {
      handleOnMouseLeave();
    },
    onMouseEnter: function onMouseEnter() {
      handleOnMouseEnter();
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: classNames("".concat(prefixCls, "-sub"), restProps.popupClassName, (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-sub-second"), restProps.level === 1), _defineProperty(_classNames3, "".concat(prefixCls, "-sub-third"), restProps.level === 2), _classNames3))
  }, _mapInstanceProperty(_context4 = toArray(children)).call(_context4, function (item, index) {
    var key = item.key || index;
    return /*#__PURE__*/React.cloneElement(item, {
      key: key,
      level: restProps.level + 1,
      keyValue: key,
      collapsed: collapsed,
      mode: mode,
      theme: theme,
      selectedKey: selectedKey,
      setSelectedKeyPath: setSelectedKeyPath,
      openKeys: openKeys,
      forceSubMenuRender: forceSubMenuRender,
      triggerSubMenuAction: triggerSubMenuAction,
      handleOnOpenChange: handleOnOpenChange,
      handleOnClick: handleOnClick,
      inlineIndent: inlineIndent,
      paddingLeft: curPaddingLeft,
      parentPath: restProps.parentPath
    });
  }))), {
    arrow: false,
    placement: 'rightTop',
    gap: 0,
    visible: isVertical && !disabled ? visible : false,
    disabled: isVertical ? undefined : true,
    prefixCls: 'kd-menu-popper',
    popperClassName: theme === 'light' ? 'light' : ''
  });

  if (isVertical) {
    return verticalView;
  } else {
    var _classNames4, _context5;

    return /*#__PURE__*/React.createElement("li", _extends({
      ref: subMenuRef,
      className: classNames(prefixCls, className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-collapsed"), collapsed), _defineProperty(_classNames4, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames4, "".concat(prefixCls, "-active"), Array.isArray(selectedKeyPath) && _includesInstanceProperty(selectedKeyPath).call(selectedKeyPath, keyValue)), _classNames4)),
      key: keyValue
    }, mouseEvent, {
      style: style
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(prefixCls, "-title")),
      style: titleStyle
    }, icon && /*#__PURE__*/React.cloneElement(renderReactNodeFunction(icon), {
      className: classNames("".concat(prefixCls, "-icon"))
    }), renderItemTitle(), renderItemArrow()), /*#__PURE__*/React.createElement("div", {
      style: getCurrentStyle(),
      ref: subMenuWrapperRef
    }, /*#__PURE__*/React.createElement("ul", {
      className: classNames("".concat(prefixCls, "-sub"), restProps.popupClassName)
    }, _mapInstanceProperty(_context5 = toArray(children)).call(_context5, function (item, index) {
      var key = item.key || index;
      return /*#__PURE__*/React.cloneElement(item, {
        key: key,
        level: restProps.level + 1,
        keyValue: key,
        collapsed: collapsed,
        mode: mode,
        selectedKey: selectedKey,
        setSelectedKeyPath: setSelectedKeyPath,
        openKeys: openKeys,
        forceSubMenuRender: forceSubMenuRender,
        triggerSubMenuAction: triggerSubMenuAction,
        handleOnOpenChange: handleOnOpenChange,
        handleOnClick: handleOnClick,
        inlineIndent: inlineIndent,
        paddingLeft: curPaddingLeft,
        parentPath: restProps.parentPath
      });
    }))));
  }
};

SubMenu.displayName = 'SubMenu';
export default SubMenu;